// extracted by mini-css-extract-plugin
export default {"wrapper":"template_wrapper__NTvwo","slider":"template_slider__UKtTw","content":"template_content__tNPYz"};